import { css } from 'styled-components'

export const responsibleSwap = css`
  &:nth-child(1){
    display: block !important;
    @media (max-width: 60rem){
      display: none !important;
    }
  }
  &:nth-child(2){
    display: none !important;
    @media (max-width: 60rem){
      display: block !important;
    }
  }
`
export const customResponsibleSwap = (breakpoint: string) => css`
  &:nth-child(1){
    display: block !important;
    @media (max-width: ${breakpoint}){
      display: none !important;
    }
  }
  &:nth-child(2){
    display: none !important;
    @media (max-width: ${breakpoint}){
      display: block !important;
    }
  }
`